/**
 * Global application configuration.
 * Should store run-time options, paths, flags and so on.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

// public
module.exports = {
    list: {
        filterFiles: [],
        filterStatus: null,
        filterSearch: '',
        sort: 0
    },
    constants: {
        sort: {
            BY_NAME: 0,
            BY_CATEGORY: 1,
            BY_SIZE: 2
        }
    }
};
